import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b0d1bb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "DeliveryOrderListItem" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "flex items-center justify-end" }
const _hoisted_5 = { class: "mt-1 flex flex-col" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_7 = { class: "mt-3 flex items-center justify-end" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar mr-2" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_ctx.item.invoice_number), 1),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.item.verify)
            ? (_openBlock(), _createBlock(_component_cheap, {
                key: 0,
                class: "small green mr-4"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Включена верификация ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.item.wait_list_status)
            ? (_openBlock(), _createBlock(_component_cheap, {
                key: 1,
                class: "small yellow mr-4"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.item.wait_list_status), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.DispatcherOrderStatusesEnum[_ctx.item.status])
            ? (_openBlock(), _createBlock(_component_cheap, {
                key: 2,
                class: _normalizeClass(["small", {
                            red: _ctx.item.status === 'not_assigned',
                            primary: _ctx.item.status === 'assigned_to_courier',
                            green: _ctx.item.status === 'cargo_handling',
                            yellow: _ctx.item.status === 'taken',
                        }])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.DispatcherOrderStatusesEnum[_ctx.item.status]), 1)
                ]),
                _: 1
              }, 8, ["class"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("span", null, "Компания: " + _toDisplayString(_ctx.item.company_name), 1),
      _createElementVNode("span", null, "Номер 1С: " + _toDisplayString(_ctx.item.number_1c || 'Не указан'), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", null, _toDisplayString(_ctx.item.address), 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.item.full_name), 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.item.phone), 1)
      ]),
      (Boolean(_ctx.item.courier))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("span", null, "Курьер: " + _toDisplayString(_ctx.item.courier.full_name), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.isCanClose)
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 0,
            class: "primary text small mr-3",
            loading: _ctx.state.is_loading,
            onClick: _ctx.close
          }, {
            default: _withCtx(() => [
              _hoisted_8,
              _createTextVNode(" Закрыть ДК ")
            ]),
            _: 1
          }, 8, ["loading", "onClick"]))
        : _createCommentVNode("", true),
      (_ctx.isCanChangeDate)
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 1,
            loading: _ctx.state.is_loading,
            class: "primary text small mr-3",
            onClick: _ctx.emitDate
          }, {
            default: _withCtx(() => [
              _hoisted_9,
              _createTextVNode(" Перенести дату ")
            ]),
            _: 1
          }, 8, ["loading", "onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_the_button, {
        class: "red text small",
        loading: _ctx.state.is_loading,
        onClick: _ctx.remove
      }, {
        default: _withCtx(() => [
          _hoisted_10,
          _createTextVNode(" Удалить ")
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ])
  ]))
}